const LOCAL_STORAGE_UTM_KEY = "utm";

const getUtm = () => {
  let utm = {};

  try {
    const stored = JSON.parse(localStorage.getItem(LOCAL_STORAGE_UTM_KEY));

    return stored || utm;
  } catch (e) {}

  return utm;
};
export default getUtm;
